// extracted by mini-css-extract-plugin
export default {"wrapper":"EditEmailModal_wrapper__TmqZ1"};